import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { truncate } from '../fns/util';
function Testimonial(_a) {
    var item = _a.item, readOnLabel = _a.readOnLabel, closeLabel = _a.closeLabel, slideChanged = _a.slideChanged;
    var _b = React.useState(''), quote = _b[0], setQuote = _b[1];
    var _c = React.useState(false), truncated = _c[0], setTruncated = _c[1];
    var _d = React.useState(false), expanded = _d[0], setExpanded = _d[1];
    var textThreshold = 200;
    var handleReadToggle = function (expand) {
        setExpanded(expand);
        setQuote(expand ? item.quote : truncate(item.quote, textThreshold));
        slideChanged();
    };
    React.useEffect(function () {
        var shouldTruncate = item.quote.length > textThreshold;
        if (shouldTruncate) {
            setQuote(truncate(item.quote, textThreshold));
            setTruncated(true);
            return;
        }
        setQuote(item.quote);
    }, []);
    return (React.createElement("div", { className: 'autonet-testimonial-item' },
        React.createElement("div", { className: "autonet-testimonial-quote ".concat(expanded ? 'expanded' : 'contracted') },
            quote,
            truncated &&
                React.createElement("strong", { onClick: function () { return handleReadToggle(!expanded); } }, expanded ? closeLabel : readOnLabel)),
        React.createElement("div", { className: 'autonet-testimonial-title element-flex' },
            React.createElement("div", { className: 'autonet-testimonial-logotype-container' }, item.imgPath
                ? React.createElement("img", { className: 'autonet-testimonial-logotype', src: item.imgPath, width: '50', height: '50', alt: item.title })
                : React.createElement("i", { className: 'fa-regular fa-image' })),
            React.createElement("div", { className: 'autonet-testimonial-name-company testimonial-slideshow' },
                React.createElement("div", { className: 'autonet-testimonial-quoter' }, item.quoter),
                React.createElement("div", { className: 'autonet-testimonial-title-and-company' }, item.titleAndCompany)))));
}
function Navigation(_a) {
    var direction = _a.direction, swiper = _a.swiper;
    var isPrev = direction === 'prev';
    var handleDirection = function () {
        if (!swiper) {
            return;
        }
        if (isPrev) {
            swiper.slidePrev();
            return;
        }
        swiper.slideNext();
    };
    return (React.createElement("div", { className: "autonet-direction ".concat(direction), onClick: handleDirection },
        React.createElement("i", { className: "fa-regular fa-chevron-".concat(isPrev ? 'left' : 'right') })));
}
export function Testimonials(_a) {
    var items = _a.items, readOnLabel = _a.readOnLabel, closeLabel = _a.closeLabel;
    var _b = React.useState(undefined), ref = _b[0], setRef = _b[1];
    var determineSlidesPerView = function () {
        if (window.innerWidth <= 800) {
            return 1;
        }
        if (window.innerWidth <= 1240) {
            return 2;
        }
        return 3;
    };
    return (React.createElement("div", { className: 'autonet-slideshow-wrapper element-flex' },
        React.createElement(Navigation, { swiper: ref, direction: 'prev' }),
        React.createElement(Swiper, { onInit: setRef, autoHeight: true, spaceBetween: 20, slidesPerView: determineSlidesPerView() }, items.map(function (item) {
            return React.createElement(SwiperSlide, { key: item.contentId },
                React.createElement(Testimonial, { item: item, readOnLabel: readOnLabel, closeLabel: closeLabel, slideChanged: function () {
                        if (ref) {
                            setTimeout(function () {
                                ref.update();
                            }, 1);
                        }
                    } }));
        })),
        React.createElement(Navigation, { swiper: ref, direction: 'next' })));
}
